import React, { } from 'react';
import { useIntl } from 'umi';
import SegmentMultiple from '@/pages/datalab/components/SegmentMultiple';
import { LANGUAGE_EN } from '@home/_config/config';
import { updateUrlParams } from '@/pages/datalab/utils/utils';

const CATEGORY = 'category'; // 一级类目
interface IFilterTabsProps {
  categoryData: any;
  filterValue: any;
  setFilterValue: Function;
}
export default function FilterTabs(props: IFilterTabsProps) {
  const { categoryData, filterValue, setFilterValue } = props;
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  const handleSelect = (type: string, selectedValues: string[]) => {
    setFilterValue({ ...filterValue, [type]: selectedValues });
    updateUrlParams({
      filterValue: { ...filterValue, [type]: selectedValues },
      sort: { by: 'create_time_str', order: 'desc' },
      quickValue: {
        creators: [],
        labels: [],
        cycles: [],
        chart_names: [],
      },
    });
  };

  const optionsMap = {
    [CATEGORY]: [
      {
        value: "all",
        text: "全部",
        textEn: "All",
      },
      {
        value: "my",
        text: `我的SQL视图(${categoryData?.my_count || 0})`,
        textEn: `My SQL View(${categoryData?.my_count || 0})`,
      },
      // {
      //   value: "share",
      //   text: `与我分享(${categoryData?.share_count || 0})`,
      //   textEn: `Shared with Me(${categoryData?.share_count || 0})`,
      // },
      {
        value: "others",
        text: `其他(${categoryData?.others_count || 0})`,
        textEn: `Others(${categoryData?.others_count || 0})`,
      }
    ],
  };

  return (<>
    <SegmentMultiple
      isMultiple={false}
      labelWidth={isEn ? 70 : 50}
      label={formatMessage({ id: 'dbl_sql_view_category' })}
      options={optionsMap[CATEGORY]}
      onChange={(selectedValue: string[]) => handleSelect(CATEGORY, selectedValue)}
      value={filterValue[CATEGORY]}
    />
  </>);
}
